function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/~/css-vendor/~/@babel/runtime/helpers/iterableToArray.js
// module id = 956
// module chunks = 0